<template>
  <v-ons-list-item modifier="nodivider label" :class="{ 'label--invalid': errorMsgList && errorMsgList[inputId] !== undefined }">
    <label class="center" :for="inputId">
      {{ label }}
      <small v-if="labelHelper">{{ labelHelper.replace(/^\s/, '&nbsp;') }}</small>
    </label>
    <slot name="right"></slot>
  </v-ons-list-item>
</template>

<script>
export default {
  props: ['label', 'inputId', 'errorMsgList', 'labelHelper']
}
</script>

<style>
.list-item--label:not(.list-item--expandable) .list-item--label__right {
  font-size: 16px;
  font-weight: 500;
  padding-top: 0;
  padding-bottom: 0;
  min-height: 27px;
}
</style>